export interface IProps {}

export enum CardType {
  PHONE = "telefon",
  EMAIL = "email",
  FAX = "fax",
  CENTER = "centrala",
}
